import type { ValidValue } from "../models/common/ValidValue";
export function getValidValueDisplayText(
  value: Partial<ValidValue> | null | undefined,
  dropdownDisplayMode?: any
): string {
  const code = String(value?.Code ?? "").trim();
  const description = String(value?.Description ?? "").trim();
  const mode = String(dropdownDisplayMode ?? "").trim().toLowerCase();

  if (mode === "code") return code || description;
  if (mode === "description") return description || code;
  if (mode === "both") {
    if (code && description) return `${code} - ${description}`;
    return code || description;
  }

  return description || code;
}

/**
 * Comparator that orders valid values by the text actually shown in the
 * dropdown (per DropdownDisplayMode), not by Code alone. Sorting by Code
 * leaves description-only value sets (empty codes) visually unsorted, since
 * every key collapses to "". Sorting by the display text keeps the visible
 * order correct regardless of whether codes, descriptions, or both are shown.
 */
export function compareValidValuesByDisplayText(
  a: Partial<ValidValue> | null | undefined,
  b: Partial<ValidValue> | null | undefined,
  dropdownDisplayMode?: any
): number {
  return getValidValueDisplayText(a, dropdownDisplayMode).localeCompare(
    getValidValueDisplayText(b, dropdownDisplayMode),
    undefined,
    { sensitivity: "base", numeric: true }
  );
}

